import { useCallback, useState } from 'react';
import { Icon } from '../../shared';
import styles from './MessageInput.module.css';

export interface MessageInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  placeholder?: string;
  isSending?: boolean;
  variant?: 'default' | 'compact' | 'floating';
  className?: string;
}

export function MessageInput({
  onSend,
  disabled = false,
  placeholder = 'Type your message...',
  isSending = false,
  variant = 'default',
  className = '',
}: MessageInputProps) {
  const [inputMessage, setInputMessage] = useState('');

  const handleSend = useCallback(() => {
    if (!inputMessage.trim() || disabled || isSending) return;

    onSend(inputMessage);
    setInputMessage('');
  }, [inputMessage, disabled, isSending, onSend]);

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSend();
      }
    },
    [handleSend]
  );

  return (
    <div className={`${styles.input} ${styles[variant]} ${className}`}>
      <div className={styles.inputWrapper}>
        <textarea
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          rows={1}
          disabled={disabled || isSending}
          aria-label="Message input"
          className={styles.textarea}
        />
        <button
          onClick={handleSend}
          disabled={!inputMessage.trim() || disabled || isSending}
          aria-label="Send message"
          className={styles.sendButton}
        >
          <Icon name="send" size={variant === 'compact' ? 18 : 20} />
        </button>
      </div>
    </div>
  );
}
